import * as styles from './styles.css';
import { IconFunctionalInformation12, Tooltip } from '@cian/ui-kit';
import { useUrlWithUtm } from 'shared/hooks';
import { ERowType, TAnswer } from './types';

interface IAnswerProps {
  row: TAnswer;
  needDot: boolean;
}

interface IAnswerLinkProps {
  url: string;
  text: string;
  needDot: boolean;
}

const AnswerLink: React.FC<IAnswerLinkProps> = ({ url, text, needDot }) => {
  const href = useUrlWithUtm(url);

  return (
    <a href={href} className={styles['link']} rel="noreferrer" target="_blank">
      {' ' + text}
      {needDot ? '.' : ' '}
    </a>
  );
};

export const Answer: React.FC<IAnswerProps> = ({ row, needDot }) => {
  if (row.type === ERowType.Link) {
    return <AnswerLink url={row.url} text={row.text} needDot={needDot} />;
  }

  if (row.type === ERowType.Header) {
    return <h3>{row.text}</h3>;
  }

  if (row.type === ERowType.List) {
    return (
      <ul>
        {row.rows.map((item, listKey) => (
          <li key={listKey}>
            {item.map((text, itemKey) => {
              if (text.type === ERowType.Link) {
                return (
                  <AnswerLink key={itemKey} url={text.url} text={text.text} needDot={item.length - 1 === itemKey} />
                );
              }

              return <span key={itemKey}>{text.text}</span>;
            })}
          </li>
        ))}
      </ul>
    );
  }

  if (row.type === ERowType.Tooltip) {
    return (
      <Tooltip title={row.title}>
        <IconFunctionalInformation12 color="icon-main-default" />
      </Tooltip>
    );
  }

  return <span>{row.text}</span>;
};
